import * as React from "react";
import {history} from "../redux/AppStore";
import {ConnectedRouter} from "connected-react-router";
import routes from "../routes/routes";
import "./App.scss";

// import logo from "./nzpost-logo.svg";


//@ts-ignore
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
const classNames = `grid-container-local ${isIE11?'ie11':''}`;
/**
 * Root App component
 * @constructor
 */
const App = () =>

  <main id="nzpost-js-tools" className={classNames}>
    <section className="page">
      <ConnectedRouter history={history}>
        {routes}
      </ConnectedRouter>
    </section>
  </main>
;

export default App;



// WEBPACK FOOTER //
// ./src/App/App.tsx